export interface IAddCandidate {
  personName: string;
  personEmail: string;
  personPhoneNumber?: string;
  columnCodeOrId?: string;
  notificationsEnabled?: boolean;
  askScreeningQuestions?: boolean;
  internalNote?: string;
  profileLink?: string;
  cvId?: string;
  flow?: string;
}

export class AddCandidate {
  public personName: string;
  public personEmail: string;
  public personPhoneNumber?: string;
  public columnCodeOrId?: string;
  public notificationsEnabled?: boolean;
  public askScreeningQuestions?: boolean;
  public internalNote?: string;
  public profileLink?: string;
  public cvId?: string;
  public flow?: string;

  constructor(data: IAddCandidate) {
    this.personName = data.personName;
    this.personEmail = data.personEmail;
    this.personPhoneNumber = data.personPhoneNumber;
    this.columnCodeOrId = data.columnCodeOrId;
    this.notificationsEnabled = data.notificationsEnabled;
    this.askScreeningQuestions = data.askScreeningQuestions;
    this.internalNote = data.internalNote;
    this.profileLink = data.profileLink;
    this.cvId = data.cvId;
    this.flow = data.flow;
  }
}

export interface IAddInternalCandidate {
  columnCodeOrId?: string;
  notificationsEnabled?: boolean;
  askScreeningQuestions?: boolean;
  internalNote?: string;
  profileLink?: string;
  cvId?: string;
}

export class AddInternalCandidate {
  public columnCodeOrId?: string;
  public notificationsEnabled?: boolean;
  public askScreeningQuestions?: boolean;
  public internalNote?: string;
  public profileLink?: string;
  public cvId?: string;

  constructor(data: IAddInternalCandidate) {
    this.columnCodeOrId = data.columnCodeOrId;
    this.notificationsEnabled = data.notificationsEnabled;
    this.askScreeningQuestions = data.askScreeningQuestions;
    this.internalNote = data.internalNote;
    this.profileLink = data.profileLink;
    this.cvId = data.cvId;
  }
}
